import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

export interface TableData {
  label: string;
  value: string;
}

@Component({})
export default class HandoffPatientInfo extends Vue {
  @Prop(Array)
  tableData!: TableData[];

  @Prop(Array)
  list!: string[];

  getStyle(data: any) {
    return data.backgroundColor !== undefined
      ? {
          backgroundColor: data.backgroundColor,
          color: data.textColor
        }
      : "";
  }
}
